import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Auth from "./auth/reducer";
import Profile from "./profile/reducer";
// Test
import Test from "./test/reducer";
// Cutom
import Data from "./data/reducer";
import Task from "./task/reducer";
import Contract from "./contract/reducer";
import Notice from "./notice/reducer";
import Employee from "./employee/reducer";
import Client from "./client/reducer";
import CardPurchase from "./card/reducer";
import ScrapingRuns from "./scraping/reducer";
// Tax Portal
import TaxPortal from "./taxPortal/reducer";
import Custodian from "./custodian/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Auth,
  Profile,
  // Test
  Test,
  //custom
  Data,
  Task,
  Contract,
  Notice,
  Employee,
  CardPurchase,
  Client,
  ScrapingRuns,
  // Tax Portal
  TaxPortal,
  Custodian,
});

export default rootReducer;
